export const LIMITLESS_EVENT: number = 9999;